module.exports = {"540122100":"当曲卡镇","540122101":"羊八井镇","540122200":"格达乡","540122201":"宁中乡","540122202":"公塘乡","540122203":"龙仁乡","540122204":"乌玛塘乡","540122205":"纳木湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540122.json
// module id = 2813
// module chunks = 0